var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrezor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "191px",
    height: "210px",
    viewBox: "0 0 191 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6,19C72,19,52.9,38.1,52.9,61.7v16c-8.3,1.5-16.6,3.5-16.6,6.1v83.6 c0,0,0,2.3,2.6,3.4c9.4,3.8,46.4,16.9,54.9,19.9c1.1,0.4,1.4,0.4,1.7,0.4c0.4,0,0.6,0,1.7-0.4c8.5-3,45.6-16.1,55-19.9 c2.4-1,2.5-3.3,2.5-3.3V83.8c0-2.6-8.2-4.7-16.5-6.1v-16C138.2,38.1,119.1,19,95.6,19z M95.6,39.4c13.9,0,22.3,8.4,22.3,22.3v13.9 c-15.6-1.1-28.9-1.1-44.6,0V61.7C73.3,47.8,81.7,39.4,95.6,39.4z M95.5,96.1c19.4,0,35.7,1.5,35.7,4.2c0,0,0,51.3,0,52.1 c0,0.8-0.1,0.9-0.8,1.2c-0.7,0.3-33.1,12-33.1,12s-1.3,0.4-1.7,0.4c-0.4,0-1.7-0.5-1.7-0.5s-32.4-11.7-33.1-12 c-0.7-0.3-0.8-0.4-0.8-1.2c0-0.8,0-52.1,0-52.1C59.8,97.5,76.1,96.1,95.5,96.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrezor);
export default __webpack_public_path__ + "static/media/trezor.96711d34e9556183d13f036a91ea6a1c.svg";
export { ForwardRef as ReactComponent };